<mat-toolbar color="accent">
  <mat-toolbar-row>
    <span>
      {{ subTitle }}
    </span>
    <span class="spacer"></span>
    <button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>


<div *ngIf="isUserFormLoaded()">
  
  <!-- USER INFORMATION FORM (includes password fields for both modes) -->
  <form
    [formGroup]="userForm"
    (ngSubmit)="handleUserFormSubmit()"
    id="user-info-form">

    <div class="field-container">
      <mat-form-field appearance="fill" class="field-full field-sm-half field-md-quarter">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" maxlength="50" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full field-sm-half field-md-quarter">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="first_name" maxlength="50" required />
        <mat-error *ngIf="userForm.get('first_name')?.hasError('required')">
          First name is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full field-sm-half field-md-quarter">
        <mat-label>Preferred Name</mat-label>
        <input matInput formControlName="preferred_name" maxlength="50" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full field-sm-half field-md-quarter">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="last_name" maxlength="50" required />
        <mat-error *ngIf="userForm.get('last_name')?.hasError('required')">
          Last name is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full">
        <mat-label>Email</mat-label>
        <input 
          matInput 
          formControlName="email" 
          type="email"
          inputmode="email" 
          required 
          maxlength="100" />
        <mat-error *ngIf="userForm.get('email')?.hasError('email') && !userForm.get('email')?.hasError('required')">
          Valid email address required.
        </mat-error>
        <mat-error *ngIf="userForm.get('email')?.hasError('required')">
          Email is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full ">
        <mat-label>Phone</mat-label>
        <input
          matInput
          formControlName="phone"
          type="tel"
          inputmode="tel"
          required
          maxlength="50" />
        <mat-error *ngIf="userForm.get('phone')?.hasError('pattern') && !userForm.get('phone')?.hasError('required')">
          Valid phone number required.
        </mat-error>
        <mat-error *ngIf="userForm.get('phone')?.hasError('required')">
          Phone is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full">
        <mat-label>User Name (Log In Name)</mat-label>
        <input matInput formControlName="username" required maxlength="50" />
        <mat-error *ngIf="userForm.get('username')?.hasError('required')">
          User name is required.
        </mat-error>
      </mat-form-field>

      <mat-slide-toggle formControlName="is_active" class="slider-toggle field-full">
        Is Active? (Use this to activate/deactivate user accounts. Deactivated users cannot log in.)
      </mat-slide-toggle>

      <!-- Add a horizontal divider line -->
      <mat-divider class="field-full"></mat-divider>

      <!-- Password Fields - Always visible, but validation differs by mode -->
      <mat-form-field appearance="fill" class="field-full field-sm-half ">
        <mat-label>Password{{ isRegister ? '' : ' (Optional)' }}</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          maxlength="100"
          minlength="8"
          [required]="isRegister" />
        <button
          mat-icon-button
          matSuffix
          type="button"
          tabindex="-1"
          (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Toggle password visibility'">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-hint *ngIf="isRegister">At least 8 characters with uppercase, lowercase, number, and special character</mat-hint>
        <mat-hint *ngIf="!isRegister">Leave blank to keep current password. At least 8 characters with uppercase, lowercase, number, and special character</mat-hint>
        <mat-error *ngIf="userForm.get('password')?.hasError('passwordStrength') && !userForm.get('password')?.hasError('minlength')">
          <div *ngFor="let error of userForm.get('password')?.errors | keyvalue">
            <span *ngIf="error.key !== 'passwordStrength'">{{ error.value }}</span>
          </div>
        </mat-error>
        <mat-error *ngIf="userForm.get('password')?.hasError('minlength') && !userForm.get('password')?.hasError('required')">
          Minimum of 8 characters required.
        </mat-error>
        <mat-error *ngIf="userForm.get('password')?.hasError('required')">
          Password is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-full field-sm-half">
        <mat-label>Confirm Password{{ isRegister ? '' : ' (If changing)' }}</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="confirm_password"
          maxlength="100"
          [required]="isRegister" />
        <mat-error *ngIf="userForm.get('confirm_password')?.hasError('confirmPassword')">
          Confirm password does not match password.
        </mat-error>
        <mat-error *ngIf="userForm.get('confirm_password')?.hasError('required')">
          Confirm password is required.
        </mat-error>
      </mat-form-field>

      <mat-slide-toggle formControlName="has_password_change" class="slider-toggle field-full">
        Require Password Change On Login
      </mat-slide-toggle>
    </div>

    <div class="field-container justify-end form-controls">
      <button
        class="field-full field-sm-auto"
        [disabled]="!isUserFormValid()"
        mat-raised-button
        type="submit"
        color="primary">
        <mat-icon>save</mat-icon>
        <span>{{ isRegister ? 'Create' : 'Submit' }}</span>
      </button>
    </div>
  </form>

<!-- PASSWORD FORM - Only for Registration -->
<form
  *ngIf="isRegister && passwordForm"
  [formGroup]="passwordForm"
  (ngSubmit)="handlePasswordSubmit()"
  id="password-form">

  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <span>Set Password</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="field-container">
    <p class="field-full">
      <mat-icon class="info-icon">info</mat-icon>
      Password will be set when you save the user information above.
    </p>
  </div>
</form>


<!-- ROLE FORM - Only show after user is created -->
<form
  *ngIf="!isRegister"
  [formGroup]="roleForm"
  (ngSubmit)="handleRoleFormSubmit()"
  id="role-form">

  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <span>User Role(s)</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <table mat-table [dataSource]="activeRoles" class="mat-elevation-z8 roles-table field-full">
    
    <!-- Role Name Column -->
    <ng-container matColumnDef="role_name">
      <th mat-header-cell *matHeaderCellDef>Role Name</th>
      <td mat-cell *matCellDef="let role">{{ role.role_name | titlecase }}</td>
    </ng-container>

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>Select</th>
      <td mat-cell *matCellDef="let role">
        <mat-checkbox 
          [checked]="isRoleSelected(role.role_id)"
          (change)="toggleRole(role.role_id, $event.checked)"
          [attr.aria-label]="'Select ' + role.role_name">
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedRoleColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedRoleColumns;"></tr>
  </table>

  <mat-error 
    *ngIf="roleForm.get('roles')?.hasError('selectedRole') && roleForm.get('roles')?.touched"
    class="role-error">
    At least one user role must be selected.
  </mat-error>

  <div class="field-container justify-end form-controls">
    <button
      class="field-full field-sm-auto"
      [disabled]="!isRoleFormValid()"
      mat-raised-button
      type="submit"
      color="primary">
      <mat-icon>save</mat-icon>
      <span>Submit</span>
    </button>
  </div>
</form>
</div>